import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import styled, { css, keyframes } from 'styled-components';
import { useLocation, useNavigate } from "react-router-dom";

import { addRazorpayFundAccount,
         getRazorpayVPAFundAccount,
         sendRazorpayOfframpRequest } from "../../services/backendHelpers";

import { BTX_INR_RATE } from "../../services/balances/balanceServiceNew";
import Spinner from "react-spinners/PuffLoader";
import Sheet  from 'react-modal-sheet';


import back from '../../styles/assets/back_arrow.svg';
import UPITicked from '../../styles/assets/tick_upi_icon.svg';
import NonUPITicked from '../../styles/assets/non_tick_upi.svg';

import AddUPIIcon from '../../styles/assets/add_upi_icon.svg';

import UPIMessageLoader from '../../styles/assets/upi_message_loader.svg';
import UPIMessageSuccess from '../../styles/assets/upi_message_success.svg';
import UPIMessageFail from '../../styles/assets/upi_message_fail.svg';
import RazorpayOffRampVerifyComponent from './RazorpayOffRampVerifyComponent';
import AddPanPageComponent from './SadAddPanPage';
import {analytics } from '../../services/eventTracker';

const MIN_WITHDRAW_AMOUNT = 100;

const UPIMessageDiv = styled.div`
position: absolute;
display: flex;
    align-items: center;
    height: 40px;
    background: #26283E;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.12), 0px 16px 16px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    flex: none;
    order: 0;
    flex-grow: 0;
    right: 16px;
    left: 16px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: #FFFFFF;
`

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    
    height: 100vh;
    flex-direction: column;
    padding: 16px;
    background: rgba(14, 15, 24, 1);
`;

const StyledContainerSheet = styled.div`
    background: rgba(14,15,24,1);
    width: 100%;
    height: 100%;
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const PaymentList = styled.ul`
    list-style: none;
    padding: 0;
`;

const ListItemText = styled.span`
    color: #fff;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    /* identical to box height, or 125% */

    letter-spacing: 0.1px;
`;

const NewPaymentForm = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    flex-direction: column;
    width: 100%;
`;

const NewPaymentInput = styled.input`
    flex: 1;
    padding: 10px;
    width: 100%;
`;

const AddPaymentButton = styled.button`
    background: linear-gradient(90.07deg, #3999F9 29.06%, #4A7DFF 96.96%);
    border-radius: 8px;
    color: #282c34;
    padding: 10px;
    border: none;
    cursor: pointer;
    height: 52px;
    width: 100%;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    /* identical to box height, or 125% */

    letter-spacing: 0.1px;

    /* Light Button / Primary Foreground */

    color: #FFFFFF;
    &:hover {
    background-color: #21a1c1;
    }
`;

const CancelPaymentButton = styled.button`
    color: #fff;
    background-color: #f44336;
    border: none;
    padding: 10px;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
    flex: 1;
`;

const Input = styled.input`
    margin: 20px 0;
    padding: 10px;
    color: #ffffff; // Change this to set the text color
    background: #171929;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    /* identical to box height, or 125% */
    height: 51px;
    width: 100%;
    letter-spacing: 0.1px;
    // Placeholder color
    ::placeholder {
    color: #616685;
    opacity: 1; // Firefox uses opacity instead of color
    }

    // Placeholder color for Internet Explorer
    :-ms-input-placeholder {
    color: #616685;
    }

    // Placeholder color for Edge
    ::-ms-input-placeholder {
    color: #616685;
    }
`;

type OffRampButtonProps = {
    isActive: boolean;
}

const OffRampButton = styled.button<OffRampButtonProps>`
  padding: 10px 20px;
  color: ${props => (props.isActive ? '#fff' : '#616685')};
  background: ${props => (props.isActive 
    ? 'linear-gradient(90.07deg, #3999F9 29.06%, #4A7DFF 96.96%)' 
    : '#141624')};
  border: none;
  cursor: pointer;
  border-radius: 8px;
  width: 100%;
  height: 44px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.1px;
  opacity: 1;

  &:hover {
    background-color: ${props => (props.isActive ? '#45a049' : '#141624')};
  }
`;

const BackTitle = styled.div`
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #FFFFFF;
`;

const Title = styled.div`
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #FFFFFF;
`


const UPITitle = styled.div`
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #FFFFFF;
`;

const pressAnimation = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(0.95); }
  100% { transform: scale(1); }
`;

const PaymentListItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #333;
    padding: 0; // remove padding from li, we will set it on button
    margin-bottom: 10px;
    background: #171929;
    border-radius: 12px;
    height: 55px;
    
`;

const ListItemButton = styled.button`
    background: transparent;
    border: none;
    color: #fff;
    text-align: left;
    width: 100%;
    padding: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    &:active {
    animation: ${pressAnimation} 0.2s ease;
    }

    &:focus {
    outline: none;
    }
`;

type ListItemImageProps = {
    show: boolean;
}

const ListItemImage = styled.img<ListItemImageProps>`
   width: 24px;
   height: 24px;
   margin-right: 10px;
   display: ${props => (props.show ? 'block' : 'none')};

`;

const UPIMessageImage = styled.img`
    width: 20px;
    height: 20px;
    margin-right: 16px;
    margin-left: 16px;
`;


const PlayerSheet = styled(Sheet)`
  margin: 0 auto;
  max-width: 680px;

  .react-modal-sheet-container {
    background-color: rgba(14,15,24,1) !important;
  }

  .react-modal-sheet-header {
    height: 50px; // Adjust this value to change the height of the header
  }

  .react-modal-sheet-backdrop {
    background-color: rgba(0, 0, 0, 0.8) !important;
  }

  .react-modal-sheet-drag-indicator {
    background-color: #666 !important;
  }
`;

const OfframpMessageSpan = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    flex: none;
    order: 0;
    flex-grow: 0;
`;

const WITHDRAW_BEFORE_KYC = 5000;

const PaymentListItemComponent = ({
    payment, handlePaymentSelectionChange,
    selectedPayment, setSelectedPayment
}:any) => {
    
    const handleChange = (e: any) => {
        setSelectedPayment(payment._id);
        handlePaymentSelectionChange(payment._id);
    };
    
    return (
        <>
          <PaymentListItem>
            <ListItemButton onClick={handleChange}>
              <ListItemImage 
                  src={UPITicked}
                  show={payment._id === selectedPayment}
              // Call the same function that was called on radio change
                  />
              <ListItemImage 
                  src={NonUPITicked}
                  show={payment._id != selectedPayment}
              />
              <ListItemText>{payment.vpaAddress}</ListItemText>
            </ListItemButton>
          </PaymentListItem>
        </>
    );
};

function PaymentListComponent({
    handlePaymentSelectionChange, value, onAddPayment, 
    onChange, selectedPayment, setSelectedPayment, payments, isLoading }:any){
        
    const [showForm, setShowForm] = useState(false);    
    
    if (isLoading) {
        // Show spinner while data is loading
        return (
            <div style={{
                marginTop: 28,
                display:'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
              <Spinner color="#ffffff" />
            </div>
        );
    }

    // Show payments when data is loaded and there are payments
    return (
        <>
          <div style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: 28,
              width: '100%'
          }}>
            <UPITitle>
              Your UPI Accounts
            </UPITitle>
            <PaymentList>
              {payments.map((payment:any, index:any) => (
                  <PaymentListItemComponent
                      key={index} payment={payment}
                      handlePaymentSelectionChange={
                      handlePaymentSelectionChange}
                      selectedPayment={selectedPayment}
                      setSelectedPayment={setSelectedPayment}
                  />
              ))}
        <PaymentListItem>
          <ListItemButton onClick={()=>{setShowForm(!showForm)}}>
            <ListItemImage 
                src={AddUPIIcon}
                show={true}
            // Call the same function that was called on radio change
            />
            <ListItemText>{`Add new UPI Account`}</ListItemText>
          </ListItemButton>
        </PaymentListItem>
          </PaymentList>
            </div>
            <PlayerSheet isOpen={showForm}
                         snapPoints={[700, 0]}
                         onClose={() => setShowForm(false)}>
              <PlayerSheet.Container>
                <PlayerSheet.Header />
                <PlayerSheet.Content>
                  <StyledContainerSheet>
                    <UPITitle>
                      Add UPI Account
                    </UPITitle>
                    <Input
                        value={value}
                        onChange={onChange}
                        placeholder="Enter UPI ID"
                    />
                    <AddPaymentButton
                        style={{marginLeft:10}}
                        onClick={()=>{
                            setShowForm(false);
                            onAddPayment()}}>
                      Confirm new account
                    </AddPaymentButton>
                  </StyledContainerSheet>
                </PlayerSheet.Content>
              </PlayerSheet.Container>
              <PlayerSheet.Backdrop/>
            </PlayerSheet>
        </>
    );
};



const RazorpayOffRampPage = () => {
    const navigate: any = useNavigate();
    const [selectedPaymentID, setSelectedPaymentID] = useState(null);
    const [gcBalance, setGcBalance] = useState(0);
    //const [upiAddState, setUPIAddState] = useState(null as any);
    const [upiAddState, setUPIAddState] = useState(null as any);
    const [newPaymentID, setNewPaymentID] = useState('' as any);
    const [offRampProcessState, setOffRampProcessState] = useState(null as any);
    const [paymentListLoading, setPaymentListLoading] = useState(false);
    const [payments, setPayments] = useState([]);
    const [selectedPayment, setSelectedPayment] = useState('');
    const [userVerified, setUserVerified] = useState(false);
    const [netWithdrawDone, setNetWithdrawDone] = useState(0);
    const [userVerificationState, setUserVerificationState] = useState('');
    const [panNumber, setPanNumber] = useState('');
    

    const getSetVPAFundAccounts = async () => {
        setPaymentListLoading(true);
        let fundAccountsData = await getRazorpayVPAFundAccount({});
        setUserVerified(fundAccountsData.kycCompleted)
        setPanNumber(fundAccountsData.panNumber);
        setUserVerificationState(
            fundAccountsData.kycStatus);
        console.log('fundAccountsData',
                    fundAccountsData)
        setNetWithdrawDone(fundAccountsData.netWithdraw);
        setPayments(fundAccountsData.fundAccounts);
        if(fundAccountsData.fundAccounts.length>0){
            setSelectedPayment(fundAccountsData.fundAccounts[0]._id);
            handlePaymentSelectionChange(fundAccountsData.fundAccounts[0]._id);
        }
        setPaymentListLoading(false);
    }
    
    useEffect(()=> {
        let userId:any = Number(localStorage.getItem('glipUserId'));
        analytics.identify(userId);
        getSetVPAFundAccounts()
    },[])

    const handleAddPayment = async () => {
        setUPIAddState('PROCESSING');
        let fundAccount = await addRazorpayFundAccount(
            {vpaId: newPaymentID});
        if(!fundAccount){
            setUPIAddState('FAILED')
            setTimeout(()=>{
                setUPIAddState(null);
            }, 3000);
            return;
        }
        getSetVPAFundAccounts();
        setUPIAddState('SUCCESS')
        setTimeout(()=>{
            setUPIAddState(null);
        }, 3000);
        
    };
    
    const handleInputChange = (event:any) => {
        setNewPaymentID(event.target.value);
    };
    
    const [amount, setAmount] = useState('');
    const [amountAfterTax, setAmountAfterTax] = useState(0);
    
    const handlePaymentSelectionChange = (val:any) => {
        setSelectedPaymentID(val);
    };
    
    const goBack = () => {
        navigate(-1);
    };

    const refetchStatus = async () => {
        await getSetVPAFundAccounts();
    }
    
    useEffect(() => {
        const url = window.location.href;
        const urlParams = new URLSearchParams(url);
        const gcBalance = urlParams.get('gc_balance');
        setGcBalance(Number(gcBalance));
        (window as any).callbackBackPressed  = () => {
            // unregister the callback
            goBack();
        };
    }, []);
    

    const handleAmountChange = (event:any) => {
        setAmount(event.target.value);
        let inrAmount = Number(event.target.value)*BTX_INR_RATE;
        let amountAfterTax = inrAmount - (inrAmount*0.3);
        // ensure max 2 decimal places
        amountAfterTax = Math.round(amountAfterTax * 100) / 100
        setAmountAfterTax(amountAfterTax);
    };
    
    const handleSubmit = async () => {
        // handle submission
        if(Number(amount) < MIN_WITHDRAW_AMOUNT){
            return;
        }
        if(Number(amount)> gcBalance){
            toast.error('Amount greater than your balance');
            return;
        }
        if((Number(amount)*BTX_INR_RATE) + netWithdrawDone >WITHDRAW_BEFORE_KYC){
            setNetWithdrawDone(Number(amount) + netWithdrawDone);
            if(!userVerified){
                return;
            }
        }
        if(!selectedPaymentID){
            toast.error('Please first add your UPI');
        }
        setOffRampProcessState('PROCESSING');
        let resp = await sendRazorpayOfframpRequest({
            amount, razorpayFundAccountId: selectedPaymentID});
        
        if(!resp){   
            setOffRampProcessState('FAILED')
            return
        }
        if(resp.error){
            setOffRampProcessState('FAILED')
            alert(resp.error);
            return
        }
        
        analytics.track("success_offramp", {
            "btx_amount": amount,
        });
        setOffRampProcessState('SUCCESS');
    };
    

    let offRampMessage = '';
    if(offRampProcessState == 'PROCESSING'){
        offRampMessage = 'Transfer submitted.Processing...';
    }
    else if(offRampProcessState == 'SUCCESS'){
        offRampMessage = 'Transfer successfully completed';
    }
    else if(offRampProcessState == 'FAILED'){
        offRampMessage = 'Transfer failed';
    }
    
    //if(!userVerified){
    console.log('panNumber', panNumber)
    if(!panNumber || panNumber  == ''){
        return (
            <AddPanPageComponent
                refetchStatus={refetchStatus}
            />
        )
    }
    
    if(!userVerified && netWithdrawDone > WITHDRAW_BEFORE_KYC){
        return (
            <RazorpayOffRampVerifyComponent
                userVerificationState={userVerificationState}
                refetchStatus={refetchStatus}
            >
            </RazorpayOffRampVerifyComponent>
        );
    }
    
    
    if(offRampProcessState){
        return (
            <Container>
              <div style={{display:'flex', justifyContent:'center',
                           alignItems:'center',
                           height: '100%',
                           flexDirection: 'column'
              }}>
                <div>
                  {(offRampProcessState == 'PROCESSING') && (
                      <UPIMessageImage style={{width: 48,height: 48, marginBottom:10}} src={UPIMessageLoader} />)}
                  {(offRampProcessState == 'FAILED') && (
                      <UPIMessageImage style={{width: 48,height: 48, marginBottom:10}} src={UPIMessageFail} />)}
                  {(offRampProcessState == 'SUCCESS') && (
                      <UPIMessageImage style={{width: 48,height: 48, marginBottom:10}} src={UPIMessageSuccess} /> )}
                </div>
                <div>
                  <OfframpMessageSpan>{offRampMessage}</OfframpMessageSpan>
                </div>
              </div>
              <div>
                {(offRampProcessState == 'FAILED') && (<OffRampButton isActive={false} onClick={()=>setOffRampProcessState(null)} style={{marginBottom: 10, color: '#fff'}}>
                  {(<>Try again</>)}
                </OffRampButton>)}
                <OffRampButton isActive={true} onClick={goBack}>
                  {(<>Back to Wallet</>)}
                </OffRampButton>
              </div>
            </Container>
        );
    }
    
    let upiMessage = '';
    if(upiAddState == 'PROCESSING'){
        upiMessage = 'Adding UPI. Processing...';
    }
    else if(upiAddState == 'SUCCESS'){
        upiMessage = 'New UPI added!';
    }
    else if(upiAddState == 'FAILED'){
        upiMessage = 'UPI Issue';
    }
    

    return (
        <Container>
          {upiAddState && (
              <UPIMessageDiv>
                {(upiAddState == 'PROCESSING') && (
                    <UPIMessageImage src={UPIMessageLoader} />)}
                {(upiAddState == 'FAILED') && (
                    <UPIMessageImage src={UPIMessageFail} />)}
                {(upiAddState == 'SUCCESS') && (
                    <UPIMessageImage src={UPIMessageSuccess} /> )}
                <span>{upiMessage}</span>
              </UPIMessageDiv>
          )}
          {(!upiAddState)  && (
              <div onClick={() => goBack()} style={{position: 'absolute', top: 0, left: 20}}>
                <img style={{position: 'absolute', top: 20}} src={back} alt='back arrow' className='hover'/>
                <BackTitle className='hover' style={{display: 'flex', justifyContent: 'center', marginTop: 16, marginLeft: 30}}>
                  Withdraw
                </BackTitle>
              </div>
          )}
          
          <div>
            <Title style={{marginTop: 60}}>Convert BTX to INR</Title>
            <Input type="number" 
                   value={amount} onChange={handleAmountChange} 
                   placeholder="Enter btx  amount to convert"
            />
            <div style={{color:"white", marginBottom:30, fontSize:14}}>*You will get {amountAfterTax} INR after taxes</div>
            <PaymentListComponent
                handlePaymentSelectionChange={
                handlePaymentSelectionChange} 
                value={newPaymentID}
                onChange={handleInputChange}
                onAddPayment={handleAddPayment}
                upiAddState={upiAddState}
                payments={payments}
                isLoading={paymentListLoading}
                selectedPayment={selectedPayment}
                setSelectedPayment={setSelectedPayment}
            />
          </div>
          
          <div>
          {/* <div style={{color:"white", marginBottom:20, opacity: 0.6}}>*30% withdrawal tax will be deducted and submitted to Govt. against your PAN</div>

          <div style={{color:"green", marginBottom:30}}>Our payout provider has updated their system. We are working with them to resolve the issue. You can continue using BTX - USDC swap.</div>

            <OffRampButton isActive={false}>
              Confirm
            </OffRampButton> */}

            <div style={{color:"white", marginBottom:30}}>*30% withdrawal tax will be deducted and submitted to Govt. against your PAN</div>
            <OffRampButton isActive={Number(amount)>=MIN_WITHDRAW_AMOUNT && paymentListLoading ==false } onClick={handleSubmit}>
              {(Number(amount)>=MIN_WITHDRAW_AMOUNT) && (<>Confirm</>)}
              {(Number(amount)<MIN_WITHDRAW_AMOUNT) && (<>{`Amount should be atleast ${MIN_WITHDRAW_AMOUNT} `}</>)}
            </OffRampButton>

          </div>
        </Container>
    );
};

export default RazorpayOffRampPage;

